<div class="projects-header">
  <div class="left-section">
    <h1 class="title">Projects</h1>
    
    <app-search-autocomplete 
      placeholder="Search project"
      searchType="project"
      (searchSubmitted)="onSearch($event)"
      (resultSelected)="onResultSelected($event)"
      #searchComponent
      class="search-component">
    </app-search-autocomplete>
  </div>
  
  <div class="right-section">
    <app-notification-inbox></app-notification-inbox>

    <button mat-stroked-button
            class="import-btn"
            (click)="onImport()">
      <mat-icon>upload</mat-icon>
      <span>Import</span>
    </button>

    <button mat-flat-button
            color="primary"
            class="new-project-btn"
            (click)="onNewProject()">
      <mat-icon>add</mat-icon>
      <span>New Project</span>
    </button>
  </div>
</div>
